window.addEventListener("DOMContentLoaded", (event) => {
    document
      .querySelector("#closeButton")
      .addEventListener("click", function () {
        const container = document.querySelector(".espaBanner");
        container.classList.add("slide-left");
        // Optionally, you could remove the container from the DOM after the transition
        // completes by using a 'transitionend' event listener:
        container.addEventListener("transitionend", function () {
          container.parentNode.removeChild(container);
        });
      });
  });